'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { map } from 'rxjs/operators/map';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { of } from 'rxjs/observable/of';
import { startWith } from 'rxjs/operators/startWith';
import { FETCH_SMART_CONTENT_DATA_CHECK } from '../actions/ActionTypes';
import { requestedSmartContentDataCheck, requestedSmartContentDataCheckSucceeded, requestedSmartContentDataCheckFailed } from '../actions/SmartContentDataCheckActions';
export default ((action$, _, {
  ActivitiesClient
}) => action$.ofType(FETCH_SMART_CONTENT_DATA_CHECK).pipe(mergeMap(({
  payload: {
    analyticsPageId
  }
}) => ActivitiesClient.fetchSmartContentActivites(analyticsPageId).pipe(map(requestedSmartContentDataCheckSucceeded), catchError(error => of(requestedSmartContentDataCheckFailed(error))), startWith(requestedSmartContentDataCheck())))));